import React, { ReactElement } from "react";
import { Icon } from "../components/icon";
import QrSvg from "./qr-code.svg";
import QrAddSvg from "./qr-code-add.svg";

/**
 * Function that creates an SvgIcon by wrapping the SVG with an Icon component
 * - function so we easily can create similar SVG icons in the same way
 * - by exporting them as variables, the auto import of VS code can find them easily
 * - we wrap it so the icons have the same width/height
 */
function createSvgIcon(iconName: string, svg: ReactElement) {
	function EmbeddedSvgIcon(props: React.HTMLProps<HTMLSpanElement>) {
		return (
			<Icon iconName={iconName} {...props}>
				{svg}
			</Icon>
		);
	}
	EmbeddedSvgIcon.displayName = "EmbeddedSvgIcon";

	return EmbeddedSvgIcon;
}

export const QrIcon = createSvgIcon("qr-code", <QrSvg />);
export const QrAddIcon = createSvgIcon("qr-code-add", <QrAddSvg />);
